import { EventEmitter, OnInit, Output } from '@angular/core';
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'ap-filter-list',
    templateUrl: './filter-list.component.html',
    styleUrls: ['./filter-list.component.css'],
    standalone: false
})
export class FilterListComponent implements OnInit {
  showFilters = false;
  collapse = 'collapse';

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      if (params['filter'] === 'on') {
        this.showFilters = true;
        this.collapse = 'collapse in';
      } else {
        this.showFilters = false;
        this.collapse = 'collapse';
      }
    });
  }
}
